import { render, staticRenderFns } from "./UpdateAttr.vue?vue&type=template&id=7db6cc90"
import script from "./UpdateAttr.vue?vue&type=script&lang=js"
export * from "./UpdateAttr.vue?vue&type=script&lang=js"
import style0 from "./UpdateAttr.vue?vue&type=style&index=0&id=7db6cc90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports